import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Opened as a popup by GoogleCalendarWidget. Reads the ?code= param from
// Google's OAuth redirect, posts it back to the opener, then closes itself.
export default function GoogleCalendarCallbackView() {
	const [searchParams] = useSearchParams();
	const [status, setStatus] = useState('connecting');

	useEffect(() => {
		const code = searchParams.get('code');
		const error = searchParams.get('error');

		if (error || !code) {
			setStatus('error');
			return;
		}

		if (window.opener) {
			window.opener.postMessage(
				{ type: 'GOOGLE_CALENDAR_CALLBACK', code },
				window.location.origin
			);
			setStatus('done');
			window.close();
		} else {
			setStatus('error');
		}
	}, [searchParams]);

	const messages = {
		connecting: 'Connecting Google Calendar…',
		done: 'Connected! You can close this window.',
		error: 'Something went wrong. Please close this window and try again.',
	};

	return (
		<div className='flex items-center justify-center min-h-screen bg-gray-50'>
			<div className='text-center p-8 rounded-xl border border-gray-200 bg-white max-w-sm w-full shadow'>
				<p className='text-sm font-medium text-gray-700'>{messages[status]}</p>
			</div>
		</div>
	);
}
